import { Component, OnInit, TemplateRef } from "@angular/core";
import { fuseAnimations } from "@fuse/animations";
import { DatePipe, Location } from "@angular/common";
import { forwardRef, Input, ViewChild } from "@angular/core";
import { FormControl, NG_VALUE_ACCESSOR } from "@angular/forms";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDatepicker,
  MatDialog,
} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import * as _moment from "moment";
import { default as _rollupMoment, Moment } from "moment";
import { ParseService } from "app/shared/common/parse/parse.service";
import { StorageConfiguration } from "app/shared/common/storage-setting/storage-configuration";
import { start } from "repl";

const moment = _rollupMoment || _moment;

export const YEAR_MODE_FORMATS = {
  parse: {
    dateInput: "YYYY",
  },
  display: {
    dateInput: "YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-my-leave",
  templateUrl: "./my-leave.component.html",
  styleUrls: ["./my-leave.component.scss"],
  animations: fuseAnimations,
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: "pt" },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: YEAR_MODE_FORMATS },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MyLeaveComponent),
      multi: true,
    },
  ],
})
export class MyLeaveComponent implements OnInit {
  leaveCols = [
    { field: "position", header: "Position" },
    { field: "months", header: "Months" },
    { field: "noOfDays", header: "No of days" },
    { field: "details", header: "Details" },
  ];
  leaveResults = [];
  leaveResCount = 12;
  profileId = "";
  monthsOfTheYear = [
    { value: 0, month: "January" },
    { value: 1, month: "February" },
    { value: 2, month: "March" },
    { value: 3, month: "April" },
    { value: 4, month: "May" },
    { value: 5, month: "June" },
    { value: 6, month: "July" },
    { value: 7, month: "August" },
    { value: 8, month: "September" },
    { value: 9, month: "October" },
    { value: 10, month: "November" },
    { value: 11, month: "December" },
  ];
  nonWorkingDays = [];
  holidaysList = [];
  selectedDate = new Date();
  profileIds = [];
  allEmployeeLeaveResults = [];
  totalRecords = 0;
  searchValue = "";
  userName = "";
  userImage = "";
  selectedLeaveList = [];
  @ViewChild("deleteLeavePopup", { static: false })
  deleteLeavePopup: TemplateRef<any>;
  selectedLeaveDate = "";
  selctedResource = "";
  holidayCount = 0;
  selectedHolidayYear = new Date();
  datePipe = new DatePipe("en-US");

  daysOfTheMonth = [
    { value: 0 },
    { value: 1 },
    { value: 2 },
    { value: 3 },
    { value: 4 },
    { value: 5 },
    { value: 6 },
    { value: 7 },
    { value: 8 },
    { value: 9 },
    { value: 10 },
    { value: 11 },
    { value: 12 },
    { value: 13 },
    { value: 14 },
    { value: 15 },
    { value: 16 },
    { value: 17 },
    { value: 18 },
    { value: 19 },
    { value: 20 },
    { value: 21 },
    { value: 22 },
    { value: 23 },
    { value: 24 },
    { value: 25 },
    { value: 26 },
    { value: 27 },
    { value: 28 },
    { value: 29 },
    { value: 30 },
  ];

  _max: Moment;
  @Input()
  get max(): number | Date {
    return this._max ? this._max.year() : undefined;
  }
  set max(max: number | Date) {
    if (max) {
      const momentDate =
        typeof max === "number" ? moment([max, 0, 1]) : moment(max);
      this._max = momentDate.isValid() ? momentDate : undefined;
    }
  }

  _min: Moment;
  @Input()
  get min(): number | Date {
    return this._min ? this._min.year() : undefined;
  }
  set min(min: number | Date) {
    if (min) {
      const momentDate =
        typeof min === "number" ? moment([min, 0, 1]) : moment(min);
      this._min = momentDate.isValid() ? momentDate : undefined;
    }
  }

  touchUi = false;
  empRole = "";
  selectedYear = new Date();

  @ViewChild(MatDatepicker, { static: false }) _picker: MatDatepicker<Moment>;
  _inputCtrl: FormControl = new FormControl();
  _inputCtr2: FormControl = new FormControl();

  /** send the focus away from the input so it doesn't open again */
  _takeFocusAway = (datepicker: MatDatepicker<Moment>) => {};

  constructor(
    private _location: Location,
    private parseService: ParseService,
    private storageConfiguration: StorageConfiguration,
    public dialog: MatDialog
  ) {}

  async ngOnInit() {
    this.empRole = this.storageConfiguration.sessionGetItem(
      this.storageConfiguration.role
    );
    this.profileId =
      this.parseService.instance.User.current().get("profile").id;

    await this.getHolidays();
    this.getLeaveDetails();
  }

  async getHolidays() {
    const holidaysInstance =
      this.parseService.instance.Object.extend("Holidays");
    const holidayQuery = new this.parseService.instance.Query(holidaysInstance);
    let currentYear = new Date(this.selectedDate).getFullYear();
    holidayQuery.equalTo("year", currentYear);
    const leaveResults = await holidayQuery.find();
    if (leaveResults.length > 0) {
      let holidayList =
        leaveResults[0].get("dateList") == undefined
          ? {}
          : leaveResults[0].get("dateList");
      for (let months in holidayList) {
        if (holidayList[months].length != 0) {
          let parsedMonths = parseInt(months);
          holidayList[months].forEach((element) => {
            const officialLeaves = new Date(currentYear, parsedMonths, element);
            const epochLeaves = officialLeaves.getTime();
            this.nonWorkingDays.push(epochLeaves);
          });
        }
      }
    }
    let date = new Date();
    let year = date.getFullYear();
    let totalMonths = 12;
    for (let i = 0; i < totalMonths; i++) {
      let k = i + 1;
      let daysInMonth = new Date(year, k, 0).getDate();
      for (let j = 0; j < daysInMonth; j++) {
        let datesAll = new Date(year, i, j);
        let dayOfWeek = datesAll.getDay();
        let dateOfMonth = datesAll.getDate();
        let isEvenWeek = Math.ceil(dateOfMonth / 7);
        let epochOddDates = datesAll.getTime();
        if (dayOfWeek == 0) {
          if (this.nonWorkingDays.indexOf(epochOddDates) === -1) {
            this.nonWorkingDays.push(epochOddDates);
          }
        }
        if (dayOfWeek == 6 && isEvenWeek % 2 != 0) {
          if (this.nonWorkingDays.indexOf(epochOddDates) === -1) {
            this.nonWorkingDays.push(epochOddDates);
          }
        }
      }
    }
    let previousYear = year - 1;
    let daysInMonthLast = new Date(previousYear, 12, 0).getDate();
    for (let d = 1; d <= daysInMonthLast; d++) {
      let lastdatesAll = new Date(previousYear, 11, d);
      let lastdayOfWeek = lastdatesAll.getDay();
      let lastdateOfMonth = lastdatesAll.getDate();
      let lastisEvenWeek = Math.ceil(lastdateOfMonth / 7);
      let lastepochOddDates = lastdatesAll.getTime();
      if (lastdayOfWeek == 0) {
        if (this.nonWorkingDays.indexOf(lastepochOddDates) === -1) {
          this.nonWorkingDays.push(lastepochOddDates);
        }
      }
      if (lastdayOfWeek == 6 && lastisEvenWeek % 2 != 0) {
        if (this.nonWorkingDays.indexOf(lastepochOddDates) === -1) {
          this.nonWorkingDays.push(lastepochOddDates);
        }
      }
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  async leaveYearSelectedHandler(
    chosenDate: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    this.selectedDate = chosenDate.toDate();
    this.selectedYear = this.selectedDate;
    await this.getHolidays();
    this.getLeaveDetails();
    datepicker.close();

    if (!this.isYearEnabled(chosenDate.year())) {
      return;
    }
    chosenDate.set({ date: 1 });
    this._inputCtrl.setValue(chosenDate, { emitEvent: false });
    this.onChange(chosenDate.toDate());
    this.onTouched();
  }

  openDatepickerOnClick(datepicker: MatDatepicker<Moment>) {
    if (!datepicker.opened) {
      datepicker.open();
    }
  }

  // Function to call when the date changes.
  onChange = (year: Date) => {};

  // Function to call when the input is touched (when a star is clicked).
  onTouched = () => {};

  /** Whether the given year is enabled. */
  isYearEnabled(year: number) {
    // disable if the year is greater than maxDate lower than minDate
    if (
      year === undefined ||
      year === null ||
      (this._max && year > this._max.year()) ||
      (this._min && year < this._min.year())
    ) {
      return false;
    }

    return true;
  }

  backlocation() {
    this._location.back();
  }

  async getLeaveDetails() {
    let firstDayOfYear = new Date(this.selectedDate.getFullYear(), 0, 1);
    let lastDate = new Date(this.selectedDate.getFullYear(), 11, 31).setHours(
      23,
      59,
      59,
      999
    );
    let lastDayOfYear = new Date(lastDate);
    this.leaveResults = [];
    let leaveClass = this.parseService.instance.Object.extend("Leaves");
    let query = new this.parseService.instance.Query(leaveClass);
    query.equalTo("requesterId", {
      __type: "Pointer",
      className: "Profile",
      objectId: this.profileId,
    });
    query.greaterThan("startDate", firstDayOfYear);
    query.lessThan("startDate", lastDayOfYear);
    let results = await query.find();
    for (const element of this.monthsOfTheYear) {
      let noOfDays = 0;
      let details = [];
      this.leaveResults.push({
        position: element.value + 1,
        monthValue: element.value,
        months: element.month,
        noOfDays: noOfDays,
        noOfHours: 0,
        details: details,
      });
    }
    let year = new Date(this.selectedDate).getFullYear();
    for (const element of this.monthsOfTheYear) {
      let firstDate = new Date(year, element.value, 1).setHours(0, 0, 0, 0);
      let lastDate = new Date(year, element.value + 1, 0).setHours(
        23,
        59,
        59,
        999
      );
      let firstDay = new Date(firstDate);
      let lastDay = new Date(lastDate);
      let data = results.filter((item) => {
        return (
          item.get("startDate").getTime() >= firstDay &&
          item.get("startDate").getTime() <= lastDay
        );
      });
      let details = [];
      for (const res of data) {
        console.log("res", res);
        let totalHours = 0;

        if (res.get("requestType") != "Permission") {
          this.calculateTotalLeaves(res.get("startDate"), res.get("endDate"));
        }

        if (res.get("leaveType") == "Sick-Leave") {
          this.calculateSickLeave(res.get("startDate"), res.get("endDate"));
        }

        if (res.get("leaveType") == "Casual-Leave") {
          this.calculateCasualLeave(res.get("startDate"), res.get("endDate"));
        }

        if (res.get("requestType") == "Permission") {
          const stDate = res.get("startDate");
          let startDate = new Date(stDate);
          let startTime = res.get("startTime");
          let endTime = res.get("endTime");
          const combinedStartDate = this.combineDateAndTime(
            new Date(startDate),
            startTime
          );
          const combinedEndDate = this.combineDateAndTime(
            new Date(startDate),
            endTime
          );
          totalHours = this.calculateTimeDifference(
            combinedStartDate,
            combinedEndDate
          );
          this.hoursBetweenAllEmployees(totalHours, res.get("startDate"));
        }

        details.push({
          requestType: res.get("requestType"),
          status: res.get("status"),
          leaveType: res.get("leaveType"),
          startDate: res.get("startDate"),
          endDate: res.get("endDate"),
          totalDays: res.get("totalDays"),
          startDateValue: this.datePipe.transform(
            new Date(res.get("startDate")),
            "dd-MMM-yyyy"
          ),
          endDateValue: this.datePipe.transform(
            new Date(res.get("endDate")),
            "dd-MMM-yyyy"
          ),
          startTime: res.get("startTime"),
          endTime: res.get("endTime"),
          totalHours: totalHours,
        });
      }
      let index = this.leaveResults.findIndex(
        (x) => x.monthValue == element.value
      );
      if (index != -1) {
        this.leaveResults[index].details = details;
      }
    }
  }

  combineDateAndTime(date, time) {
    var timeArray = time.split(":");
    var hours = parseInt(timeArray[0]);
    var minutes = parseInt(timeArray[1].split(" ")[0]);
    var meridian = timeArray[1].split(" ")[1];

    if (meridian === "PM" && hours !== 12) {
      hours += 12;
    } else if (meridian === "AM" && hours === 12) {
      hours = 0;
    }

    date.setHours(hours, minutes, 0, 0);

    return date;
  }

  calculateTimeDifference(startDate, endDate) {
    var differenceInMilliseconds = endDate - startDate;
    var differenceInSeconds = differenceInMilliseconds / 1000;
    var differenceInMinutes = differenceInSeconds / 60;
    var differenceInHours = differenceInMinutes / 60;
    return differenceInHours;
  }

  convertTime12to24(time12h) {
    const [time, modifier] = time12h.split(" ");

    let [hours, minutes] = time.split(":");

    if (hours === "12") {
      hours = "12";
    }

    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }

    return `${hours}:${minutes}`;
  }

  calculateTotalLeaves(date1, date2) {
    let startDate = new Date(date1);
    let endDate = new Date(date2);
    let daylist = this.getDaysArray(new Date(startDate), new Date(endDate));
    for (var i = 0; i < daylist.length; i++) {
      let holiday = this.nonWorkingDays.findIndex((x) => x === daylist[i]);
      if (holiday != -1) {
        daylist.splice(holiday, 1);
      } else {
        let currentMonth = new Date(daylist[i]).getMonth();
        let index = this.leaveResults.findIndex(
          (x) => x.monthValue == currentMonth
        );
        this.leaveResults[index].noOfDays += 1;
      }
    }
  }

  hoursBetweenAllEmployees(totalHours, startDate) {
    let currentMonth = new Date(startDate).getMonth();
    let index = this.leaveResults.findIndex(
      (x) => x.monthValue == currentMonth
    );
    this.leaveResults[index].noOfHours += totalHours;
  }

  calculateSickLeave(date1, date2) {
    let startDate = new Date(date1);
    let endDate = new Date(date2);
    let daylist = this.getDaysArray(new Date(startDate), new Date(endDate));
    for (var i = 0; i < daylist.length; i++) {
      let holiday = this.nonWorkingDays.findIndex((x) => x === daylist[i]);
      if (holiday != -1) {
        daylist.splice(holiday, 1);
      } else {
        let currentMonth = new Date(daylist[i]).getMonth();
        let index = this.leaveResults.findIndex(
          (x) => x.monthValue == currentMonth
        );
        this.leaveResults[index].noOfSickLeave += 1;
      }
    }
  }

  calculateCasualLeave(date1, date2) {
    let startDate = new Date(date1);
    let endDate = new Date(date2);
    let daylist = this.getDaysArray(new Date(startDate), new Date(endDate));
    for (var i = 0; i < daylist.length; i++) {
      let holiday = this.nonWorkingDays.findIndex((x) => x === daylist[i]);
      if (holiday != -1) {
        daylist.splice(holiday, 1);
      } else {
        let currentMonth = new Date(daylist[i]).getMonth();
        let index = this.leaveResults.findIndex(
          (x) => x.monthValue == currentMonth
        );
        this.leaveResults[index].noOfCasualLeave += 1;
      }
    }
  }

  getDaysArray(start, end) {
    for (var arr = [], dt = start; dt <= end; dt.setDate(dt.getDate() + 1)) {
      arr.push(new Date(new Date(dt).getTime()).setHours(0, 0, 0, 0));
    }
    return arr;
  }
}
